<template>
  <a-layout class='index animated fadeIn s_bf'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="name" label="类型名称" name="name">
        <a-input v-model:value="form.name" placeholder='请输入类型名称' />
      </a-form-item>
      <a-form-item ref="remarks" label="备注" name="remarks">
        <a-textarea v-model:value="form.remarks" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
        <a-button type="primary" @click="onSubmit">
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-layout>
</template>
<script>
  import { ref, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import {  TypeAdd } from "@/api/store";
  // 初始化默认筛选项数值
  let defForm = {
    name: '',
    remarks:''
  }
  export default {
    name:'addStoreType',
    components: {},
    props: {
      
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        rules: {
          name: [
            { required: true, message: '请输入类型名称', trigger: 'blur' }
          ],
        }
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await TypeAdd(form.value).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            emit('storetypesubmit')
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
